// extracted by mini-css-extract-plugin
module.exports = {"tableWrapper":"styles_tableWrapper__3hJTr","col":"styles_col__1Ng61","fulfillmentStatus":"styles_fulfillmentStatus__198Qp","emailCol":"styles_emailCol__2RNEP"};